export default __webpack_public_path__ + "static/media/Detail-Manajemen-Asset.ae3efca1.png";